/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */

// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, FileData, prepare } from 'yapi-to-typescript'
// @ts-ignore
// prettier-ignore
import type { RequestConfig, RequestFunctionRestArgs } from 'yapi-to-typescript'
// @ts-ignore
import request from './request';

type UserRequestRestArgs = RequestFunctionRestArgs<typeof request>;

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult,
> = (TRequestConfig['requestDataOptional'] extends true
  ? (requestData?: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult
  : (
      requestData: TRequestData,
      ...args: RequestFunctionRestArgs<typeof request>
    ) => TRequestResult) & {
  requestConfig: TRequestConfig;
};

const mockUrl_0_0_0_0 = 'http://127.0.0.1:50505/mock/0' as any;
const devUrl_0_0_0_0 = '' as any;
const prodUrl_0_0_0_0 = '' as any;
const dataKey_0_0_0_0 = 'data' as any;

/**
 * 接口 用户登录 的 **请求类型**
 *
 * @分类 default
 * @请求头 `POST /admin/login`
 */
export interface CreateAdminLoginRequest {
  /**
   * 用户名
   */
  username: string;
  /**
   * 密码
   */
  password: string;
  /**
   * 验证码标识
   */
  captchaId: string;
  /**
   * 用户输入的验证码
   */
  verifyCode: string;
  /**
   * oidc认证标识
   */
  uid?: string;
  /**
   * oidc认证token
   */
  token?: string;
}

/**
 * 接口 用户登录 的 **返回类型**
 *
 * @分类 default
 * @请求头 `POST /admin/login`
 */
export interface CreateAdminLoginResponse {
  /**
   * JWT身份Token
   */
  token: string;
}

/**
 * 接口 用户登录 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `POST /admin/login`
 */
type CreateAdminLoginRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/login',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 用户登录 的 **请求配置**
 *
 * @分类 default
 * @请求头 `POST /admin/login`
 */
const createAdminLoginRequestConfig: CreateAdminLoginRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/login',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'createAdminLogin',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 用户登录 的 **请求函数**
 *
 * @分类 default
 * @请求头 `POST /admin/login`
 */
export const createAdminLogin = /*#__PURE__*/ (
  requestData: CreateAdminLoginRequest,
  ...args: UserRequestRestArgs
) => {
  return request<CreateAdminLoginResponse>(
    prepare(createAdminLoginRequestConfig, requestData),
    ...args,
  );
};

createAdminLogin.requestConfig = createAdminLoginRequestConfig;

/**
 * 接口 设备是否已经和用户绑定 的 **请求类型**
 *
 * @分类 default
 * @请求头 `GET /admin/login/device/enrolled/{deviceId}`
 */
export interface FetchDeviceEnrolledDeviceIdRequest {
  deviceId: string;
}

/**
 * 接口 设备是否已经和用户绑定 的 **返回类型**
 *
 * @分类 default
 * @请求头 `GET /admin/login/device/enrolled/{deviceId}`
 */
export type FetchDeviceEnrolledDeviceIdResponse = boolean;

/**
 * 接口 设备是否已经和用户绑定 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `GET /admin/login/device/enrolled/{deviceId}`
 */
type FetchDeviceEnrolledDeviceIdRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/login/device/enrolled/{deviceId}',
    'data',
    'deviceId',
    string,
    false
  >
>;

/**
 * 接口 设备是否已经和用户绑定 的 **请求配置**
 *
 * @分类 default
 * @请求头 `GET /admin/login/device/enrolled/{deviceId}`
 */
const fetchDeviceEnrolledDeviceIdRequestConfig: FetchDeviceEnrolledDeviceIdRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: '/admin/login/device/enrolled/{deviceId}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: ['deviceId'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'fetchDeviceEnrolledDeviceId',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 设备是否已经和用户绑定 的 **请求函数**
 *
 * @分类 default
 * @请求头 `GET /admin/login/device/enrolled/{deviceId}`
 */
export const fetchDeviceEnrolledDeviceId = /*#__PURE__*/ (
  requestData: FetchDeviceEnrolledDeviceIdRequest,
  ...args: UserRequestRestArgs
) => {
  return request<FetchDeviceEnrolledDeviceIdResponse>(
    prepare(fetchDeviceEnrolledDeviceIdRequestConfig, requestData),
    ...args,
  );
};

fetchDeviceEnrolledDeviceId.requestConfig = fetchDeviceEnrolledDeviceIdRequestConfig;

/**
 * 接口 将设备与用户绑定，以支持指纹登录 的 **请求类型**
 *
 * @分类 default
 * @请求头 `POST /admin/login/device/register`
 */
export interface CreateDeviceRegisterRequest {
  /**
   * 设备Id
   */
  deviceId: string;
  /**
   * 设备品牌
   */
  deviceBrand?: string;
  /**
   * 设备型号
   */
  deviceModel?: string;
  /**
   * 设备类型
   */
  deviceType?: string;
  /**
   * 操作系统及版本
   */
  system?: string;
  /**
   * 客户端平台
   */
  platform?: string;
}

/**
 * 接口 将设备与用户绑定，以支持指纹登录 的 **返回类型**
 *
 * @分类 default
 * @请求头 `POST /admin/login/device/register`
 */
export type CreateDeviceRegisterResponse = boolean;

/**
 * 接口 将设备与用户绑定，以支持指纹登录 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `POST /admin/login/device/register`
 */
type CreateDeviceRegisterRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/login/device/register',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 将设备与用户绑定，以支持指纹登录 的 **请求配置**
 *
 * @分类 default
 * @请求头 `POST /admin/login/device/register`
 */
const createDeviceRegisterRequestConfig: CreateDeviceRegisterRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/login/device/register',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'createDeviceRegister',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 将设备与用户绑定，以支持指纹登录 的 **请求函数**
 *
 * @分类 default
 * @请求头 `POST /admin/login/device/register`
 */
export const createDeviceRegister = /*#__PURE__*/ (
  requestData: CreateDeviceRegisterRequest,
  ...args: UserRequestRestArgs
) => {
  return request<CreateDeviceRegisterResponse>(
    prepare(createDeviceRegisterRequestConfig, requestData),
    ...args,
  );
};

createDeviceRegister.requestConfig = createDeviceRegisterRequestConfig;

/**
 * 接口 用户指纹登录 的 **请求类型**
 *
 * @分类 default
 * @请求头 `POST /admin/login/biometric`
 */
export interface CreateBiometricRequest {
  /**
   * 设备Id
   */
  deviceId: string;
  /**
   * 设备品牌
   */
  deviceBrand?: string;
  /**
   * 设备型号
   */
  deviceModel?: string;
  /**
   * 设备类型
   */
  deviceType?: string;
  /**
   * 操作系统及版本
   */
  system?: string;
  /**
   * 客户端平台
   */
  platform?: string;
}

/**
 * 接口 用户指纹登录 的 **返回类型**
 *
 * @分类 default
 * @请求头 `POST /admin/login/biometric`
 */
export interface CreateBiometricResponse {
  /**
   * JWT身份Token
   */
  token: string;
}

/**
 * 接口 用户指纹登录 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `POST /admin/login/biometric`
 */
type CreateBiometricRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/login/biometric',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 用户指纹登录 的 **请求配置**
 *
 * @分类 default
 * @请求头 `POST /admin/login/biometric`
 */
const createBiometricRequestConfig: CreateBiometricRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/login/biometric',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'createBiometric',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 用户指纹登录 的 **请求函数**
 *
 * @分类 default
 * @请求头 `POST /admin/login/biometric`
 */
export const createBiometric = /*#__PURE__*/ (
  requestData: CreateBiometricRequest,
  ...args: UserRequestRestArgs
) => {
  return request<CreateBiometricResponse>(
    prepare(createBiometricRequestConfig, requestData),
    ...args,
  );
};

createBiometric.requestConfig = createBiometricRequestConfig;

/**
 * 接口 手机登录 的 **请求类型**
 *
 * @分类 default
 * @请求头 `POST /admin/login/phone`
 */
export interface CreatePhoneRequest {
  /**
   * 手机号
   */
  phone: string;
  /**
   * 验证码标识
   */
  verifyId: string;
  /**
   * 用户输入的验证码
   */
  verifyCode: string;
}

/**
 * 接口 手机登录 的 **返回类型**
 *
 * @分类 default
 * @请求头 `POST /admin/login/phone`
 */
export interface CreatePhoneResponse {
  /**
   * JWT身份Token
   */
  token: string;
}

/**
 * 接口 手机登录 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `POST /admin/login/phone`
 */
type CreatePhoneRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/login/phone',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 手机登录 的 **请求配置**
 *
 * @分类 default
 * @请求头 `POST /admin/login/phone`
 */
const createPhoneRequestConfig: CreatePhoneRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/login/phone',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'createPhone',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 手机登录 的 **请求函数**
 *
 * @分类 default
 * @请求头 `POST /admin/login/phone`
 */
export const createPhone = /*#__PURE__*/ (
  requestData: CreatePhoneRequest,
  ...args: UserRequestRestArgs
) => {
  return request<CreatePhoneResponse>(prepare(createPhoneRequestConfig, requestData), ...args);
};

createPhone.requestConfig = createPhoneRequestConfig;

/**
 * 接口 发送手机登录验证码 的 **请求类型**
 *
 * @分类 default
 * @请求头 `POST /admin/login/phone/sms`
 */
export interface CreatePhoneSmsRequest {
  /**
   * 手机号
   */
  phone: string;
  /**
   * 验证码标识
   */
  verifyId: string;
  /**
   * 用户输入的验证码
   */
  verifyCode: string;
}

/**
 * 接口 发送手机登录验证码 的 **返回类型**
 *
 * @分类 default
 * @请求头 `POST /admin/login/phone/sms`
 */
export interface CreatePhoneSmsResponse {
  /**
   * JWT身份Token
   */
  token: string;
}

/**
 * 接口 发送手机登录验证码 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `POST /admin/login/phone/sms`
 */
type CreatePhoneSmsRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/login/phone/sms',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 发送手机登录验证码 的 **请求配置**
 *
 * @分类 default
 * @请求头 `POST /admin/login/phone/sms`
 */
const createPhoneSmsRequestConfig: CreatePhoneSmsRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/login/phone/sms',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'createPhoneSms',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 发送手机登录验证码 的 **请求函数**
 *
 * @分类 default
 * @请求头 `POST /admin/login/phone/sms`
 */
export const createPhoneSms = /*#__PURE__*/ (
  requestData: CreatePhoneSmsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<CreatePhoneSmsResponse>(
    prepare(createPhoneSmsRequestConfig, requestData),
    ...args,
  );
};

createPhoneSms.requestConfig = createPhoneSmsRequestConfig;

/**
 * 接口 验证手机登录验证码 的 **请求类型**
 *
 * @分类 default
 * @请求头 `POST /admin/login/phone/sms/verify`
 */
export interface CreatePhoneSmsVerifyRequest {
  /**
   * 手机号
   */
  phone: string;
  /**
   * 验证码标识
   */
  verifyId: string;
  /**
   * 用户输入的验证码
   */
  verifyCode: string;
}

/**
 * 接口 验证手机登录验证码 的 **返回类型**
 *
 * @分类 default
 * @请求头 `POST /admin/login/phone/sms/verify`
 */
export type CreatePhoneSmsVerifyResponse = any;

/**
 * 接口 验证手机登录验证码 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `POST /admin/login/phone/sms/verify`
 */
type CreatePhoneSmsVerifyRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/login/phone/sms/verify',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 验证手机登录验证码 的 **请求配置**
 *
 * @分类 default
 * @请求头 `POST /admin/login/phone/sms/verify`
 */
const createPhoneSmsVerifyRequestConfig: CreatePhoneSmsVerifyRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/login/phone/sms/verify',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'createPhoneSmsVerify',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 验证手机登录验证码 的 **请求函数**
 *
 * @分类 default
 * @请求头 `POST /admin/login/phone/sms/verify`
 */
export const createPhoneSmsVerify = /*#__PURE__*/ (
  requestData: CreatePhoneSmsVerifyRequest,
  ...args: UserRequestRestArgs
) => {
  return request<CreatePhoneSmsVerifyResponse>(
    prepare(createPhoneSmsVerifyRequestConfig, requestData),
    ...args,
  );
};

createPhoneSmsVerify.requestConfig = createPhoneSmsVerifyRequestConfig;

/**
 * 接口 忘记密码，通过手机验证码重置密码 的 **请求类型**
 *
 * @分类 default
 * @请求头 `POST /admin/login/password/reset`
 */
export interface CreatePasswordResetRequest {
  /**
   * 手机号
   */
  username: string;
  /**
   * 验证码标识
   */
  newPassword: string;
  /**
   * token校验
   */
  token: string;
}

/**
 * 接口 忘记密码，通过手机验证码重置密码 的 **返回类型**
 *
 * @分类 default
 * @请求头 `POST /admin/login/password/reset`
 */
export type CreatePasswordResetResponse = string;

/**
 * 接口 忘记密码，通过手机验证码重置密码 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `POST /admin/login/password/reset`
 */
type CreatePasswordResetRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/login/password/reset',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 忘记密码，通过手机验证码重置密码 的 **请求配置**
 *
 * @分类 default
 * @请求头 `POST /admin/login/password/reset`
 */
const createPasswordResetRequestConfig: CreatePasswordResetRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/login/password/reset',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'createPasswordReset',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 忘记密码，通过手机验证码重置密码 的 **请求函数**
 *
 * @分类 default
 * @请求头 `POST /admin/login/password/reset`
 */
export const createPasswordReset = /*#__PURE__*/ (
  requestData: CreatePasswordResetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<CreatePasswordResetResponse>(
    prepare(createPasswordResetRequestConfig, requestData),
    ...args,
  );
};

createPasswordReset.requestConfig = createPasswordResetRequestConfig;

/**
 * 接口 新增用户 的 **请求类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/user/add`
 */
export interface CreateUserAddRequest {
  /**
   * 所属部门编号
   */
  departmentId: number;
  /**
   * 用户姓名
   */
  name: string;
  /**
   * 登录账号
   */
  username: string;
  /**
   * 归属角色
   */
  roles: number[];
  /**
   * 呢称
   */
  nickName?: string;
  /**
   * 邮箱
   */
  email?: string;
  /**
   * 手机号
   */
  phone?: string;
  /**
   * 备注
   */
  remark?: string;
  /**
   * 状态
   */
  status?: number;
  /**
   * 默认路由
   */
  homePath?: string;
  password?: string;
  encrypted_pwd?: string;
  auth_tag?: string;
  openid?: string;
}

/**
 * 接口 新增用户 的 **返回类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/user/add`
 */
export type CreateUserAddResponse = any;

/**
 * 接口 新增用户 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/user/add`
 */
type CreateUserAddRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/sys/user/add',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 新增用户 的 **请求配置**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/user/add`
 */
const createUserAddRequestConfig: CreateUserAddRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/sys/user/add',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'createUserAdd',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 新增用户 的 **请求函数**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/user/add`
 */
export const createUserAdd = /*#__PURE__*/ (
  requestData: CreateUserAddRequest,
  ...args: UserRequestRestArgs
) => {
  return request<CreateUserAddResponse>(prepare(createUserAddRequestConfig, requestData), ...args);
};

createUserAdd.requestConfig = createUserAddRequestConfig;

/**
 * 接口 查询用户信息 的 **请求类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/user/info`
 */
export interface FetchUserInfoRequest {
  /**
   * 用户ID
   */
  userId: string;
}

/**
 * 接口 查询用户信息 的 **返回类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/user/info`
 */
export interface FetchUserInfoResponse {}

/**
 * 接口 查询用户信息 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/user/info`
 */
type FetchUserInfoRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/sys/user/info',
    'data',
    string,
    'userId',
    false
  >
>;

/**
 * 接口 查询用户信息 的 **请求配置**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/user/info`
 */
const fetchUserInfoRequestConfig: FetchUserInfoRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/sys/user/info',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: ['userId'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'fetchUserInfo',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 查询用户信息 的 **请求函数**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/user/info`
 */
export const fetchUserInfo = /*#__PURE__*/ (
  requestData: FetchUserInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<FetchUserInfoResponse>(prepare(fetchUserInfoRequestConfig, requestData), ...args);
};

fetchUserInfo.requestConfig = fetchUserInfoRequestConfig;

/**
 * 接口 批量查询用户信息 的 **请求类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/user/info`
 */
export interface CreateUserInfoRequest {
  /**
   * 用户IDs
   */
  ids: number[];
}

/**
 * 接口 批量查询用户信息 的 **返回类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/user/info`
 */
export type CreateUserInfoResponse = any;

/**
 * 接口 批量查询用户信息 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/user/info`
 */
type CreateUserInfoRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/sys/user/info',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 批量查询用户信息 的 **请求配置**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/user/info`
 */
const createUserInfoRequestConfig: CreateUserInfoRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/sys/user/info',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'createUserInfo',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 批量查询用户信息 的 **请求函数**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/user/info`
 */
export const createUserInfo = /*#__PURE__*/ (
  requestData: CreateUserInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<CreateUserInfoResponse>(
    prepare(createUserInfoRequestConfig, requestData),
    ...args,
  );
};

createUserInfo.requestConfig = createUserInfoRequestConfig;

/**
 * 接口 根据ID列表删除用户 的 **请求类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/user/delete`
 */
export interface CreateUserDeleteRequest {
  /**
   * 需要删除的用户ID列表
   */
  userIds: number[];
}

/**
 * 接口 根据ID列表删除用户 的 **返回类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/user/delete`
 */
export type CreateUserDeleteResponse = any;

/**
 * 接口 根据ID列表删除用户 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/user/delete`
 */
type CreateUserDeleteRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/sys/user/delete',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 根据ID列表删除用户 的 **请求配置**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/user/delete`
 */
const createUserDeleteRequestConfig: CreateUserDeleteRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/sys/user/delete',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'createUserDelete',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 根据ID列表删除用户 的 **请求函数**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/user/delete`
 */
export const createUserDelete = /*#__PURE__*/ (
  requestData: CreateUserDeleteRequest,
  ...args: UserRequestRestArgs
) => {
  return request<CreateUserDeleteResponse>(
    prepare(createUserDeleteRequestConfig, requestData),
    ...args,
  );
};

createUserDelete.requestConfig = createUserDeleteRequestConfig;

/**
 * 接口 分页获取用户列表 的 **请求类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/user/page`
 */
export interface CreateUserPageRequest {
  /**
   * 当前页包含数量
   */
  limit?: number;
  /**
   * 当前页包含数量
   */
  page?: number;
  /**
   * 部门列表
   */
  departmentIds?: number[];
  username: string;
}

/**
 * 接口 分页获取用户列表 的 **返回类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/user/page`
 */
export type CreateUserPageResponse = any;

/**
 * 接口 分页获取用户列表 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/user/page`
 */
type CreateUserPageRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/sys/user/page',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 分页获取用户列表 的 **请求配置**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/user/page`
 */
const createUserPageRequestConfig: CreateUserPageRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/sys/user/page',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'createUserPage',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 分页获取用户列表 的 **请求函数**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/user/page`
 */
export const createUserPage = /*#__PURE__*/ (
  requestData: CreateUserPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<CreateUserPageResponse>(
    prepare(createUserPageRequestConfig, requestData),
    ...args,
  );
};

createUserPage.requestConfig = createUserPageRequestConfig;

/**
 * 接口 更新用户信息 的 **请求类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/user/update`
 */
export interface CreateUserUpdateRequest {
  /**
   * 所属部门编号
   */
  departmentId: number;
  /**
   * 用户姓名
   */
  name: string;
  /**
   * 登录账号
   */
  username: string;
  /**
   * 归属角色
   */
  roles: number[];
  /**
   * 呢称
   */
  nickName?: string;
  /**
   * 邮箱
   */
  email?: string;
  /**
   * 手机号
   */
  phone?: string;
  /**
   * 备注
   */
  remark?: string;
  /**
   * 状态
   */
  status?: number;
  /**
   * 默认路由
   */
  homePath?: string;
  /**
   * 用户ID
   */
  id: number;
  password?: string;
  encrypted_pwd?: string;
  auth_tag?: string;
  openid?: string;
}

/**
 * 接口 更新用户信息 的 **返回类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/user/update`
 */
export type CreateUserUpdateResponse = any;

/**
 * 接口 更新用户信息 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/user/update`
 */
type CreateUserUpdateRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/sys/user/update',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 更新用户信息 的 **请求配置**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/user/update`
 */
const createUserUpdateRequestConfig: CreateUserUpdateRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/sys/user/update',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'createUserUpdate',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 更新用户信息 的 **请求函数**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/user/update`
 */
export const createUserUpdate = /*#__PURE__*/ (
  requestData: CreateUserUpdateRequest,
  ...args: UserRequestRestArgs
) => {
  return request<CreateUserUpdateResponse>(
    prepare(createUserUpdateRequestConfig, requestData),
    ...args,
  );
};

createUserUpdate.requestConfig = createUserUpdateRequestConfig;

/**
 * 接口 更改指定用户密码 的 **请求类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/user/password`
 */
export interface CreateUserPasswordRequest {
  /**
   * 管理员ID
   */
  userId: number;
  /**
   * 更改后的密码
   */
  password: string;
}

/**
 * 接口 更改指定用户密码 的 **返回类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/user/password`
 */
export type CreateUserPasswordResponse = any;

/**
 * 接口 更改指定用户密码 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/user/password`
 */
type CreateUserPasswordRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/sys/user/password',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 更改指定用户密码 的 **请求配置**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/user/password`
 */
const createUserPasswordRequestConfig: CreateUserPasswordRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/sys/user/password',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'createUserPassword',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 更改指定用户密码 的 **请求函数**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/user/password`
 */
export const createUserPassword = /*#__PURE__*/ (
  requestData: CreateUserPasswordRequest,
  ...args: UserRequestRestArgs
) => {
  return request<CreateUserPasswordResponse>(
    prepare(createUserPasswordRequestConfig, requestData),
    ...args,
  );
};

createUserPassword.requestConfig = createUserPasswordRequestConfig;

/**
 * 接口 获取用户信息 的 **请求类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/user/retrieveUser/{userid}`
 */
export interface FetchUserRetrieveUserUseridRequest {}

/**
 * 接口 获取用户信息 的 **返回类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/user/retrieveUser/{userid}`
 */
export type FetchUserRetrieveUserUseridResponse = any;

/**
 * 接口 获取用户信息 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/user/retrieveUser/{userid}`
 */
type FetchUserRetrieveUserUseridRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/sys/user/retrieveUser/{userid}',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 获取用户信息 的 **请求配置**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/user/retrieveUser/{userid}`
 */
const fetchUserRetrieveUserUseridRequestConfig: FetchUserRetrieveUserUseridRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: '/admin/sys/user/retrieveUser/{userid}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.raw,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'fetchUserRetrieveUserUserid',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 获取用户信息 的 **请求函数**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/user/retrieveUser/{userid}`
 */
export const fetchUserRetrieveUserUserid = /*#__PURE__*/ (
  requestData?: FetchUserRetrieveUserUseridRequest,
  ...args: UserRequestRestArgs
) => {
  return request<FetchUserRetrieveUserUseridResponse>(
    prepare(fetchUserRetrieveUserUseridRequestConfig, requestData),
    ...args,
  );
};

fetchUserRetrieveUserUserid.requestConfig = fetchUserRetrieveUserUseridRequestConfig;

/**
 * 接口 获取角色列表 的 **请求类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/role/list`
 */
export interface FetchRoleListRequest {}

/**
 * 接口 获取角色列表 的 **返回类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/role/list`
 */
export type FetchRoleListResponse = any;

/**
 * 接口 获取角色列表 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/role/list`
 */
type FetchRoleListRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/sys/role/list',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 获取角色列表 的 **请求配置**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/role/list`
 */
const fetchRoleListRequestConfig: FetchRoleListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/sys/role/list',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'fetchRoleList',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 获取角色列表 的 **请求函数**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/role/list`
 */
export const fetchRoleList = /*#__PURE__*/ (
  requestData?: FetchRoleListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<FetchRoleListResponse>(prepare(fetchRoleListRequestConfig, requestData), ...args);
};

fetchRoleList.requestConfig = fetchRoleListRequestConfig;

/**
 * 接口 分页查询角色信息 的 **请求类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/role/page`
 */
export interface FetchRolePageRequest {
  /**
   * 当前页包含数量
   */
  limit?: string;
  /**
   * 当前页包含数量
   */
  page?: string;
}

/**
 * 接口 分页查询角色信息 的 **返回类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/role/page`
 */
export type FetchRolePageResponse = any;

/**
 * 接口 分页查询角色信息 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/role/page`
 */
type FetchRolePageRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/sys/role/page',
    'data',
    string,
    'limit' | 'page',
    false
  >
>;

/**
 * 接口 分页查询角色信息 的 **请求配置**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/role/page`
 */
const fetchRolePageRequestConfig: FetchRolePageRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/sys/role/page',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: ['limit', 'page'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'fetchRolePage',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 分页查询角色信息 的 **请求函数**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/role/page`
 */
export const fetchRolePage = /*#__PURE__*/ (
  requestData: FetchRolePageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<FetchRolePageResponse>(prepare(fetchRolePageRequestConfig, requestData), ...args);
};

fetchRolePage.requestConfig = fetchRolePageRequestConfig;

/**
 * 接口 删除角色 的 **请求类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/role/delete`
 */
export interface CreateRoleDeleteRequest {
  /**
   * 需要删除的角色ID列表
   */
  roleIds: number[];
}

/**
 * 接口 删除角色 的 **返回类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/role/delete`
 */
export type CreateRoleDeleteResponse = any;

/**
 * 接口 删除角色 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/role/delete`
 */
type CreateRoleDeleteRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/sys/role/delete',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 删除角色 的 **请求配置**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/role/delete`
 */
const createRoleDeleteRequestConfig: CreateRoleDeleteRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/sys/role/delete',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'createRoleDelete',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 删除角色 的 **请求函数**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/role/delete`
 */
export const createRoleDelete = /*#__PURE__*/ (
  requestData: CreateRoleDeleteRequest,
  ...args: UserRequestRestArgs
) => {
  return request<CreateRoleDeleteResponse>(
    prepare(createRoleDeleteRequestConfig, requestData),
    ...args,
  );
};

createRoleDelete.requestConfig = createRoleDeleteRequestConfig;

/**
 * 接口 新增角色 的 **请求类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/role/add`
 */
export interface CreateRoleAddRequest {
  /**
   * 角色名称
   */
  name: string;
  /**
   * 角色唯一标识
   */
  label: string;
  /**
   * 角色备注
   */
  remark?: string;
  /**
   * 关联菜单、权限编号
   */
  menus?: number[];
  /**
   * 关联部门编号
   */
  depts?: number[];
}

/**
 * 接口 新增角色 的 **返回类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/role/add`
 */
export type CreateRoleAddResponse = any;

/**
 * 接口 新增角色 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/role/add`
 */
type CreateRoleAddRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/sys/role/add',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 新增角色 的 **请求配置**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/role/add`
 */
const createRoleAddRequestConfig: CreateRoleAddRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/sys/role/add',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'createRoleAdd',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 新增角色 的 **请求函数**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/role/add`
 */
export const createRoleAdd = /*#__PURE__*/ (
  requestData: CreateRoleAddRequest,
  ...args: UserRequestRestArgs
) => {
  return request<CreateRoleAddResponse>(prepare(createRoleAddRequestConfig, requestData), ...args);
};

createRoleAdd.requestConfig = createRoleAddRequestConfig;

/**
 * 接口 更新角色 的 **请求类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/role/update`
 */
export interface CreateRoleUpdateRequest {
  /**
   * 角色名称
   */
  name: string;
  /**
   * 角色唯一标识
   */
  label: string;
  /**
   * 角色备注
   */
  remark?: string;
  /**
   * 关联菜单、权限编号
   */
  menus?: number[];
  /**
   * 关联部门编号
   */
  depts?: number[];
  /**
   * 关联部门编号
   */
  roleId: number;
}

/**
 * 接口 更新角色 的 **返回类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/role/update`
 */
export type CreateRoleUpdateResponse = any;

/**
 * 接口 更新角色 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/role/update`
 */
type CreateRoleUpdateRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/sys/role/update',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 更新角色 的 **请求配置**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/role/update`
 */
const createRoleUpdateRequestConfig: CreateRoleUpdateRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/sys/role/update',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'createRoleUpdate',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 更新角色 的 **请求函数**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/role/update`
 */
export const createRoleUpdate = /*#__PURE__*/ (
  requestData: CreateRoleUpdateRequest,
  ...args: UserRequestRestArgs
) => {
  return request<CreateRoleUpdateResponse>(
    prepare(createRoleUpdateRequestConfig, requestData),
    ...args,
  );
};

createRoleUpdate.requestConfig = createRoleUpdateRequestConfig;

/**
 * 接口 获取角色信息 的 **请求类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/role/info`
 */
export interface FetchRoleInfoRequest {
  /**
   * 需要查找的角色ID
   */
  roleId: string;
}

/**
 * 接口 获取角色信息 的 **返回类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/role/info`
 */
export type FetchRoleInfoResponse = any;

/**
 * 接口 获取角色信息 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/role/info`
 */
type FetchRoleInfoRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/sys/role/info',
    'data',
    string,
    'roleId',
    false
  >
>;

/**
 * 接口 获取角色信息 的 **请求配置**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/role/info`
 */
const fetchRoleInfoRequestConfig: FetchRoleInfoRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/sys/role/info',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: ['roleId'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'fetchRoleInfo',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 获取角色信息 的 **请求函数**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/role/info`
 */
export const fetchRoleInfo = /*#__PURE__*/ (
  requestData: FetchRoleInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<FetchRoleInfoResponse>(prepare(fetchRoleInfoRequestConfig, requestData), ...args);
};

fetchRoleInfo.requestConfig = fetchRoleInfoRequestConfig;

/**
 * 接口 获取对应权限的菜单列表 的 **请求类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/menu/list`
 */
export interface FetchMenuListRequest {}

/**
 * 接口 获取对应权限的菜单列表 的 **返回类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/menu/list`
 */
export type FetchMenuListResponse = any;

/**
 * 接口 获取对应权限的菜单列表 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/menu/list`
 */
type FetchMenuListRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/sys/menu/list',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 获取对应权限的菜单列表 的 **请求配置**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/menu/list`
 */
const fetchMenuListRequestConfig: FetchMenuListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/sys/menu/list',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'fetchMenuList',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 获取对应权限的菜单列表 的 **请求函数**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/menu/list`
 */
export const fetchMenuList = /*#__PURE__*/ (
  requestData?: FetchMenuListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<FetchMenuListResponse>(prepare(fetchMenuListRequestConfig, requestData), ...args);
};

fetchMenuList.requestConfig = fetchMenuListRequestConfig;

/**
 * 接口 新增菜单或权限 的 **请求类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/menu/add`
 */
export interface CreateMenuAddRequest {
  /**
   * 菜单类型
   */
  type: number;
  /**
   * 父级菜单
   */
  parentId: number;
  /**
   * 菜单或权限名称
   */
  name: string;
  /**
   * 排序
   */
  orderNum: number;
  /**
   * 前端路由地址
   */
  router: string;
  /**
   * 菜单是否显示
   */
  isShow?: boolean;
  /**
   * 开启页面缓存
   */
  keepalive?: boolean;
  /**
   * 菜单图标
   */
  icon?: string;
  /**
   * 对应权限
   */
  perms: string;
  /**
   * 菜单路由路径或外链
   */
  viewPath: string;
  /**
   * 是否单独页面
   */
  solo?: boolean;
  /**
   * 是否需要认证
   */
  isNeedAuth?: boolean;
  /**
   * 是否uniapp页面
   */
  isUniapp?: boolean;
  /**
   * 是否微前端页面
   */
  isMicroPage?: boolean;
}

/**
 * 接口 新增菜单或权限 的 **返回类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/menu/add`
 */
export type CreateMenuAddResponse = any;

/**
 * 接口 新增菜单或权限 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/menu/add`
 */
type CreateMenuAddRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/sys/menu/add',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 新增菜单或权限 的 **请求配置**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/menu/add`
 */
const createMenuAddRequestConfig: CreateMenuAddRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/sys/menu/add',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'createMenuAdd',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 新增菜单或权限 的 **请求函数**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/menu/add`
 */
export const createMenuAdd = /*#__PURE__*/ (
  requestData: CreateMenuAddRequest,
  ...args: UserRequestRestArgs
) => {
  return request<CreateMenuAddResponse>(prepare(createMenuAddRequestConfig, requestData), ...args);
};

createMenuAdd.requestConfig = createMenuAddRequestConfig;

/**
 * 接口 更新菜单或权限 的 **请求类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/menu/update`
 */
export interface CreateMenuUpdateRequest {
  /**
   * 菜单类型
   */
  type: number;
  /**
   * 父级菜单
   */
  parentId: number;
  /**
   * 菜单或权限名称
   */
  name: string;
  /**
   * 排序
   */
  orderNum: number;
  /**
   * 前端路由地址
   */
  router: string;
  /**
   * 菜单是否显示
   */
  isShow?: boolean;
  /**
   * 开启页面缓存
   */
  keepalive?: boolean;
  /**
   * 菜单图标
   */
  icon?: string;
  /**
   * 对应权限
   */
  perms: string;
  /**
   * 菜单路由路径或外链
   */
  viewPath: string;
  /**
   * 是否单独页面
   */
  solo?: boolean;
  /**
   * 是否需要认证
   */
  isNeedAuth?: boolean;
  /**
   * 是否uniapp页面
   */
  isUniapp?: boolean;
  /**
   * 是否微前端页面
   */
  isMicroPage?: boolean;
  /**
   * 更新的菜单ID
   */
  menuId: number;
}

/**
 * 接口 更新菜单或权限 的 **返回类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/menu/update`
 */
export type CreateMenuUpdateResponse = any;

/**
 * 接口 更新菜单或权限 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/menu/update`
 */
type CreateMenuUpdateRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/sys/menu/update',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 更新菜单或权限 的 **请求配置**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/menu/update`
 */
const createMenuUpdateRequestConfig: CreateMenuUpdateRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/sys/menu/update',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'createMenuUpdate',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 更新菜单或权限 的 **请求函数**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/menu/update`
 */
export const createMenuUpdate = /*#__PURE__*/ (
  requestData: CreateMenuUpdateRequest,
  ...args: UserRequestRestArgs
) => {
  return request<CreateMenuUpdateResponse>(
    prepare(createMenuUpdateRequestConfig, requestData),
    ...args,
  );
};

createMenuUpdate.requestConfig = createMenuUpdateRequestConfig;

/**
 * 接口 删除菜单或权限 的 **请求类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/menu/delete`
 */
export interface CreateMenuDeleteRequest {
  /**
   * 删除的菜单ID
   */
  menuId: number;
}

/**
 * 接口 删除菜单或权限 的 **返回类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/menu/delete`
 */
export type CreateMenuDeleteResponse = any;

/**
 * 接口 删除菜单或权限 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/menu/delete`
 */
type CreateMenuDeleteRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/sys/menu/delete',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 删除菜单或权限 的 **请求配置**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/menu/delete`
 */
const createMenuDeleteRequestConfig: CreateMenuDeleteRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/sys/menu/delete',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'createMenuDelete',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 删除菜单或权限 的 **请求函数**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/menu/delete`
 */
export const createMenuDelete = /*#__PURE__*/ (
  requestData: CreateMenuDeleteRequest,
  ...args: UserRequestRestArgs
) => {
  return request<CreateMenuDeleteResponse>(
    prepare(createMenuDeleteRequestConfig, requestData),
    ...args,
  );
};

createMenuDelete.requestConfig = createMenuDeleteRequestConfig;

/**
 * 接口 菜单或权限信息 的 **请求类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/menu/info`
 */
export interface FetchMenuInfoRequest {
  /**
   * 查询的菜单ID
   */
  menuId: string;
}

/**
 * 接口 菜单或权限信息 的 **返回类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/menu/info`
 */
export type FetchMenuInfoResponse = any;

/**
 * 接口 菜单或权限信息 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/menu/info`
 */
type FetchMenuInfoRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/sys/menu/info',
    'data',
    string,
    'menuId',
    false
  >
>;

/**
 * 接口 菜单或权限信息 的 **请求配置**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/menu/info`
 */
const fetchMenuInfoRequestConfig: FetchMenuInfoRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/sys/menu/info',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: ['menuId'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'fetchMenuInfo',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 菜单或权限信息 的 **请求函数**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/menu/info`
 */
export const fetchMenuInfo = /*#__PURE__*/ (
  requestData: FetchMenuInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<FetchMenuInfoResponse>(prepare(fetchMenuInfoRequestConfig, requestData), ...args);
};

fetchMenuInfo.requestConfig = fetchMenuInfoRequestConfig;

/**
 * 接口 获取系统部门列表 的 **请求类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/dept/list`
 */
export interface FetchDeptListRequest {}

/**
 * 接口 获取系统部门列表 的 **返回类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/dept/list`
 */
export interface FetchDeptListResponse {}

/**
 * 接口 获取系统部门列表 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/dept/list`
 */
type FetchDeptListRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/sys/dept/list',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 获取系统部门列表 的 **请求配置**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/dept/list`
 */
const fetchDeptListRequestConfig: FetchDeptListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/sys/dept/list',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'fetchDeptList',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 获取系统部门列表 的 **请求函数**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/dept/list`
 */
export const fetchDeptList = /*#__PURE__*/ (
  requestData?: FetchDeptListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<FetchDeptListResponse>(prepare(fetchDeptListRequestConfig, requestData), ...args);
};

fetchDeptList.requestConfig = fetchDeptListRequestConfig;

/**
 * 接口 创建系统部门 的 **请求类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/dept/add`
 */
export interface CreateDeptAddRequest {
  /**
   * 部门名称
   */
  name: string;
  /**
   * 父级部门id
   */
  parentId: number;
  /**
   * 排序编号
   */
  orderNum?: number;
}

/**
 * 接口 创建系统部门 的 **返回类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/dept/add`
 */
export type CreateDeptAddResponse = any;

/**
 * 接口 创建系统部门 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/dept/add`
 */
type CreateDeptAddRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/sys/dept/add',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 创建系统部门 的 **请求配置**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/dept/add`
 */
const createDeptAddRequestConfig: CreateDeptAddRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/sys/dept/add',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'createDeptAdd',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 创建系统部门 的 **请求函数**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/dept/add`
 */
export const createDeptAdd = /*#__PURE__*/ (
  requestData: CreateDeptAddRequest,
  ...args: UserRequestRestArgs
) => {
  return request<CreateDeptAddResponse>(prepare(createDeptAddRequestConfig, requestData), ...args);
};

createDeptAdd.requestConfig = createDeptAddRequestConfig;

/**
 * 接口 删除系统部门 的 **请求类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/dept/delete`
 */
export interface CreateDeptDeleteRequest {
  /**
   * 删除的系统部门ID
   */
  departmentId: number;
}

/**
 * 接口 删除系统部门 的 **返回类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/dept/delete`
 */
export type CreateDeptDeleteResponse = any;

/**
 * 接口 删除系统部门 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/dept/delete`
 */
type CreateDeptDeleteRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/sys/dept/delete',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 删除系统部门 的 **请求配置**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/dept/delete`
 */
const createDeptDeleteRequestConfig: CreateDeptDeleteRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/sys/dept/delete',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'createDeptDelete',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 删除系统部门 的 **请求函数**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/dept/delete`
 */
export const createDeptDelete = /*#__PURE__*/ (
  requestData: CreateDeptDeleteRequest,
  ...args: UserRequestRestArgs
) => {
  return request<CreateDeptDeleteResponse>(
    prepare(createDeptDeleteRequestConfig, requestData),
    ...args,
  );
};

createDeptDelete.requestConfig = createDeptDeleteRequestConfig;

/**
 * 接口 查询单个系统部门信息 的 **请求类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/dept/info`
 */
export interface FetchDeptInfoRequest {
  /**
   * 查询的系统部门ID
   */
  departmentId: string;
}

/**
 * 接口 查询单个系统部门信息 的 **返回类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/dept/info`
 */
export type FetchDeptInfoResponse = any;

/**
 * 接口 查询单个系统部门信息 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/dept/info`
 */
type FetchDeptInfoRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/sys/dept/info',
    'data',
    string,
    'departmentId',
    false
  >
>;

/**
 * 接口 查询单个系统部门信息 的 **请求配置**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/dept/info`
 */
const fetchDeptInfoRequestConfig: FetchDeptInfoRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/sys/dept/info',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: ['departmentId'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'fetchDeptInfo',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 查询单个系统部门信息 的 **请求函数**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/dept/info`
 */
export const fetchDeptInfo = /*#__PURE__*/ (
  requestData: FetchDeptInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<FetchDeptInfoResponse>(prepare(fetchDeptInfoRequestConfig, requestData), ...args);
};

fetchDeptInfo.requestConfig = fetchDeptInfoRequestConfig;

/**
 * 接口 更新系统部门 的 **请求类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/dept/update`
 */
export interface CreateDeptUpdateRequest {
  /**
   * 部门名称
   */
  name: string;
  /**
   * 父级部门id
   */
  parentId: number;
  /**
   * 排序编号
   */
  orderNum?: number;
  /**
   * 需要更新的部门id
   */
  id: number;
}

/**
 * 接口 更新系统部门 的 **返回类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/dept/update`
 */
export type CreateDeptUpdateResponse = any;

/**
 * 接口 更新系统部门 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/dept/update`
 */
type CreateDeptUpdateRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/sys/dept/update',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 更新系统部门 的 **请求配置**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/dept/update`
 */
const createDeptUpdateRequestConfig: CreateDeptUpdateRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/sys/dept/update',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'createDeptUpdate',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 更新系统部门 的 **请求函数**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/dept/update`
 */
export const createDeptUpdate = /*#__PURE__*/ (
  requestData: CreateDeptUpdateRequest,
  ...args: UserRequestRestArgs
) => {
  return request<CreateDeptUpdateResponse>(
    prepare(createDeptUpdateRequestConfig, requestData),
    ...args,
  );
};

createDeptUpdate.requestConfig = createDeptUpdateRequestConfig;

/**
 * 接口 管理员部门转移 的 **请求类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/dept/transfer`
 */
export interface CreateDeptTransferRequest {
  /**
   * 需要转移的管理员列表编号
   */
  userIds: number[];
  /**
   * 需要转移过去的系统部门ID
   */
  departmentId: number;
}

/**
 * 接口 管理员部门转移 的 **返回类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/dept/transfer`
 */
export type CreateDeptTransferResponse = any;

/**
 * 接口 管理员部门转移 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/dept/transfer`
 */
type CreateDeptTransferRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/sys/dept/transfer',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 管理员部门转移 的 **请求配置**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/dept/transfer`
 */
const createDeptTransferRequestConfig: CreateDeptTransferRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/sys/dept/transfer',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'createDeptTransfer',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 管理员部门转移 的 **请求函数**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/dept/transfer`
 */
export const createDeptTransfer = /*#__PURE__*/ (
  requestData: CreateDeptTransferRequest,
  ...args: UserRequestRestArgs
) => {
  return request<CreateDeptTransferResponse>(
    prepare(createDeptTransferRequestConfig, requestData),
    ...args,
  );
};

createDeptTransfer.requestConfig = createDeptTransferRequestConfig;

/**
 * 接口 部门移动排序 的 **请求类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/dept/move`
 */
export interface CreateDeptMoveRequest {
  /**
   * 部门列表
   */
  depts: {
    /**
     * 当前部门ID
     */
    id: number;
    /**
     * 移动到指定父级部门的ID
     */
    parentId: number;
  }[];
}

/**
 * 接口 部门移动排序 的 **返回类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/dept/move`
 */
export type CreateDeptMoveResponse = any;

/**
 * 接口 部门移动排序 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/dept/move`
 */
type CreateDeptMoveRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/sys/dept/move',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 部门移动排序 的 **请求配置**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/dept/move`
 */
const createDeptMoveRequestConfig: CreateDeptMoveRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/sys/dept/move',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'createDeptMove',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 部门移动排序 的 **请求函数**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/dept/move`
 */
export const createDeptMove = /*#__PURE__*/ (
  requestData: CreateDeptMoveRequest,
  ...args: UserRequestRestArgs
) => {
  return request<CreateDeptMoveResponse>(
    prepare(createDeptMoveRequestConfig, requestData),
    ...args,
  );
};

createDeptMove.requestConfig = createDeptMoveRequestConfig;

/**
 * 接口 分页查询登录日志 的 **请求类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/log/login/page`
 */
export interface FetchLogLoginPageRequest {
  /**
   * 当前页包含数量
   */
  limit?: string;
  /**
   * 当前页包含数量
   */
  page?: string;
}

/**
 * 接口 分页查询登录日志 的 **返回类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/log/login/page`
 */
export type FetchLogLoginPageResponse = {
  /**
   * 日志编号
   */
  id: number;
  /**
   * 登录ip
   */
  ip: string;
  /**
   * 系统
   */
  os: string;
  /**
   * 浏览器
   */
  browser: string;
  /**
   * 时间
   */
  time: string;
  /**
   * 登录用户名
   */
  username: string;
}[];

/**
 * 接口 分页查询登录日志 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/log/login/page`
 */
type FetchLogLoginPageRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/sys/log/login/page',
    'data',
    string,
    'limit' | 'page',
    false
  >
>;

/**
 * 接口 分页查询登录日志 的 **请求配置**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/log/login/page`
 */
const fetchLogLoginPageRequestConfig: FetchLogLoginPageRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/sys/log/login/page',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: ['limit', 'page'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'fetchLogLoginPage',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 分页查询登录日志 的 **请求函数**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/log/login/page`
 */
export const fetchLogLoginPage = /*#__PURE__*/ (
  requestData: FetchLogLoginPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<FetchLogLoginPageResponse>(
    prepare(fetchLogLoginPageRequestConfig, requestData),
    ...args,
  );
};

fetchLogLoginPage.requestConfig = fetchLogLoginPageRequestConfig;

/**
 * 接口 分页查询任务日志 的 **请求类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/log/task/page`
 */
export interface FetchLogTaskPageRequest {
  /**
   * 当前页包含数量
   */
  limit?: string;
  /**
   * 当前页包含数量
   */
  page?: string;
}

/**
 * 接口 分页查询任务日志 的 **返回类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/log/task/page`
 */
export type FetchLogTaskPageResponse = {
  /**
   * 日志编号
   */
  id: number;
  /**
   * 任务编号
   */
  taskId: number;
  /**
   * 任务名称
   */
  name: string;
  /**
   * 创建时间
   */
  createdAt: string;
  /**
   * 耗时
   */
  consumeTime: number;
  /**
   * 执行信息
   */
  detail: string;
  /**
   * 任务执行状态
   */
  status: number;
}[];

/**
 * 接口 分页查询任务日志 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/log/task/page`
 */
type FetchLogTaskPageRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/sys/log/task/page',
    'data',
    string,
    'limit' | 'page',
    false
  >
>;

/**
 * 接口 分页查询任务日志 的 **请求配置**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/log/task/page`
 */
const fetchLogTaskPageRequestConfig: FetchLogTaskPageRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/sys/log/task/page',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: ['limit', 'page'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'fetchLogTaskPage',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 分页查询任务日志 的 **请求函数**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/log/task/page`
 */
export const fetchLogTaskPage = /*#__PURE__*/ (
  requestData: FetchLogTaskPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<FetchLogTaskPageResponse>(
    prepare(fetchLogTaskPageRequestConfig, requestData),
    ...args,
  );
};

fetchLogTaskPage.requestConfig = fetchLogTaskPageRequestConfig;

/**
 * 接口 获取任务列表 的 **请求类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/task/page`
 */
export interface FetchTaskPageRequest {
  /**
   * 当前页包含数量
   */
  limit?: string;
  /**
   * 当前页包含数量
   */
  page?: string;
}

/**
 * 接口 获取任务列表 的 **返回类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/task/page`
 */
export type FetchTaskPageResponse = any;

/**
 * 接口 获取任务列表 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/task/page`
 */
type FetchTaskPageRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/sys/task/page',
    'data',
    string,
    'limit' | 'page',
    false
  >
>;

/**
 * 接口 获取任务列表 的 **请求配置**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/task/page`
 */
const fetchTaskPageRequestConfig: FetchTaskPageRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/sys/task/page',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: ['limit', 'page'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'fetchTaskPage',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 获取任务列表 的 **请求函数**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/task/page`
 */
export const fetchTaskPage = /*#__PURE__*/ (
  requestData: FetchTaskPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<FetchTaskPageResponse>(prepare(fetchTaskPageRequestConfig, requestData), ...args);
};

fetchTaskPage.requestConfig = fetchTaskPageRequestConfig;

/**
 * 接口 添加任务 的 **请求类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/task/add`
 */
export interface CreateTaskAddRequest {
  /**
   * 任务名称
   */
  name: string;
  /**
   * 调用的服务
   */
  service: string;
  /**
   * 任务类别：cron | interval
   */
  type: number;
  /**
   * 任务状态
   */
  status: number;
  /**
   * 开始时间
   */
  startTime?: string;
  /**
   * 结束时间
   */
  endTime?: string;
  /**
   * 限制执行次数，负数则无限制
   */
  limit?: number;
  /**
   * cron表达式
   */
  cron: string;
  /**
   * 执行间隔，毫秒单位
   */
  every: number;
  /**
   * 执行参数
   */
  data?: string;
  /**
   * 任务备注
   */
  remark?: string;
}

/**
 * 接口 添加任务 的 **返回类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/task/add`
 */
export type CreateTaskAddResponse = any;

/**
 * 接口 添加任务 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/task/add`
 */
type CreateTaskAddRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/sys/task/add',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 添加任务 的 **请求配置**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/task/add`
 */
const createTaskAddRequestConfig: CreateTaskAddRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/sys/task/add',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'createTaskAdd',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 添加任务 的 **请求函数**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/task/add`
 */
export const createTaskAdd = /*#__PURE__*/ (
  requestData: CreateTaskAddRequest,
  ...args: UserRequestRestArgs
) => {
  return request<CreateTaskAddResponse>(prepare(createTaskAddRequestConfig, requestData), ...args);
};

createTaskAdd.requestConfig = createTaskAddRequestConfig;

/**
 * 接口 更新任务 的 **请求类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/task/update`
 */
export interface CreateTaskUpdateRequest {
  /**
   * 任务名称
   */
  name: string;
  /**
   * 调用的服务
   */
  service: string;
  /**
   * 任务类别：cron | interval
   */
  type: number;
  /**
   * 任务状态
   */
  status: number;
  /**
   * 开始时间
   */
  startTime?: string;
  /**
   * 结束时间
   */
  endTime?: string;
  /**
   * 限制执行次数，负数则无限制
   */
  limit?: number;
  /**
   * cron表达式
   */
  cron: string;
  /**
   * 执行间隔，毫秒单位
   */
  every: number;
  /**
   * 执行参数
   */
  data?: string;
  /**
   * 任务备注
   */
  remark?: string;
  /**
   * 需要更新的任务ID
   */
  id: number;
}

/**
 * 接口 更新任务 的 **返回类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/task/update`
 */
export type CreateTaskUpdateResponse = any;

/**
 * 接口 更新任务 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/task/update`
 */
type CreateTaskUpdateRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/sys/task/update',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 更新任务 的 **请求配置**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/task/update`
 */
const createTaskUpdateRequestConfig: CreateTaskUpdateRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/sys/task/update',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'createTaskUpdate',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 更新任务 的 **请求函数**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/task/update`
 */
export const createTaskUpdate = /*#__PURE__*/ (
  requestData: CreateTaskUpdateRequest,
  ...args: UserRequestRestArgs
) => {
  return request<CreateTaskUpdateResponse>(
    prepare(createTaskUpdateRequestConfig, requestData),
    ...args,
  );
};

createTaskUpdate.requestConfig = createTaskUpdateRequestConfig;

/**
 * 接口 查询任务详细信息 的 **请求类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/task/info`
 */
export interface FetchTaskInfoRequest {
  /**
   * 任务ID
   */
  id: string;
}

/**
 * 接口 查询任务详细信息 的 **返回类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/task/info`
 */
export type FetchTaskInfoResponse = any;

/**
 * 接口 查询任务详细信息 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/task/info`
 */
type FetchTaskInfoRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/sys/task/info',
    'data',
    string,
    'id',
    false
  >
>;

/**
 * 接口 查询任务详细信息 的 **请求配置**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/task/info`
 */
const fetchTaskInfoRequestConfig: FetchTaskInfoRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/sys/task/info',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: ['id'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'fetchTaskInfo',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 查询任务详细信息 的 **请求函数**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/task/info`
 */
export const fetchTaskInfo = /*#__PURE__*/ (
  requestData: FetchTaskInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<FetchTaskInfoResponse>(prepare(fetchTaskInfoRequestConfig, requestData), ...args);
};

fetchTaskInfo.requestConfig = fetchTaskInfoRequestConfig;

/**
 * 接口 手动执行一次任务 的 **请求类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/task/once`
 */
export interface CreateTaskOnceRequest {
  /**
   * 任务ID
   */
  id: number;
}

/**
 * 接口 手动执行一次任务 的 **返回类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/task/once`
 */
export type CreateTaskOnceResponse = any;

/**
 * 接口 手动执行一次任务 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/task/once`
 */
type CreateTaskOnceRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/sys/task/once',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 手动执行一次任务 的 **请求配置**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/task/once`
 */
const createTaskOnceRequestConfig: CreateTaskOnceRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/sys/task/once',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'createTaskOnce',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 手动执行一次任务 的 **请求函数**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/task/once`
 */
export const createTaskOnce = /*#__PURE__*/ (
  requestData: CreateTaskOnceRequest,
  ...args: UserRequestRestArgs
) => {
  return request<CreateTaskOnceResponse>(
    prepare(createTaskOnceRequestConfig, requestData),
    ...args,
  );
};

createTaskOnce.requestConfig = createTaskOnceRequestConfig;

/**
 * 接口 停止任务 的 **请求类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/task/stop`
 */
export interface CreateTaskStopRequest {
  /**
   * 任务ID
   */
  id: number;
}

/**
 * 接口 停止任务 的 **返回类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/task/stop`
 */
export type CreateTaskStopResponse = any;

/**
 * 接口 停止任务 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/task/stop`
 */
type CreateTaskStopRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/sys/task/stop',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 停止任务 的 **请求配置**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/task/stop`
 */
const createTaskStopRequestConfig: CreateTaskStopRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/sys/task/stop',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'createTaskStop',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 停止任务 的 **请求函数**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/task/stop`
 */
export const createTaskStop = /*#__PURE__*/ (
  requestData: CreateTaskStopRequest,
  ...args: UserRequestRestArgs
) => {
  return request<CreateTaskStopResponse>(
    prepare(createTaskStopRequestConfig, requestData),
    ...args,
  );
};

createTaskStop.requestConfig = createTaskStopRequestConfig;

/**
 * 接口 启动任务 的 **请求类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/task/start`
 */
export interface CreateTaskStartRequest {
  /**
   * 任务ID
   */
  id: number;
}

/**
 * 接口 启动任务 的 **返回类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/task/start`
 */
export type CreateTaskStartResponse = any;

/**
 * 接口 启动任务 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/task/start`
 */
type CreateTaskStartRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/sys/task/start',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 启动任务 的 **请求配置**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/task/start`
 */
const createTaskStartRequestConfig: CreateTaskStartRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/sys/task/start',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'createTaskStart',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 启动任务 的 **请求函数**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/task/start`
 */
export const createTaskStart = /*#__PURE__*/ (
  requestData: CreateTaskStartRequest,
  ...args: UserRequestRestArgs
) => {
  return request<CreateTaskStartResponse>(
    prepare(createTaskStartRequestConfig, requestData),
    ...args,
  );
};

createTaskStart.requestConfig = createTaskStartRequestConfig;

/**
 * 接口 删除任务 的 **请求类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/task/delete`
 */
export interface CreateTaskDeleteRequest {
  /**
   * 任务ID
   */
  id: number;
}

/**
 * 接口 删除任务 的 **返回类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/task/delete`
 */
export type CreateTaskDeleteResponse = any;

/**
 * 接口 删除任务 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/task/delete`
 */
type CreateTaskDeleteRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/sys/task/delete',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 删除任务 的 **请求配置**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/task/delete`
 */
const createTaskDeleteRequestConfig: CreateTaskDeleteRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/sys/task/delete',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'createTaskDelete',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 删除任务 的 **请求函数**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/task/delete`
 */
export const createTaskDelete = /*#__PURE__*/ (
  requestData: CreateTaskDeleteRequest,
  ...args: UserRequestRestArgs
) => {
  return request<CreateTaskDeleteResponse>(
    prepare(createTaskDeleteRequestConfig, requestData),
    ...args,
  );
};

createTaskDelete.requestConfig = createTaskDeleteRequestConfig;

/**
 * 接口 查询当前在线用户 的 **请求类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/online/list`
 */
export interface FetchOnlineListRequest {}

/**
 * 接口 查询当前在线用户 的 **返回类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/online/list`
 */
export type FetchOnlineListResponse = {
  /**
   * 最近的一条登录日志ID
   */
  id: number;
  /**
   * 登录IP
   */
  ip: string;
  /**
   * 用户名
   */
  username: string;
  /**
   * 是否当前
   */
  isCurrent: boolean;
  /**
   * 登陆时间
   */
  time: string;
  /**
   * 系统
   */
  os: string;
  /**
   * 浏览器
   */
  browser: string;
  /**
   * 是否禁用
   */
  disable: boolean;
}[];

/**
 * 接口 查询当前在线用户 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/online/list`
 */
type FetchOnlineListRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/sys/online/list',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 查询当前在线用户 的 **请求配置**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/online/list`
 */
const fetchOnlineListRequestConfig: FetchOnlineListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/sys/online/list',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'fetchOnlineList',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 查询当前在线用户 的 **请求函数**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/online/list`
 */
export const fetchOnlineList = /*#__PURE__*/ (
  requestData?: FetchOnlineListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<FetchOnlineListResponse>(
    prepare(fetchOnlineListRequestConfig, requestData),
    ...args,
  );
};

fetchOnlineList.requestConfig = fetchOnlineListRequestConfig;

/**
 * 接口 下线指定在线用户 的 **请求类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/online/kick`
 */
export interface CreateOnlineKickRequest {
  /**
   * 需要下线的角色ID
   */
  id: number;
}

/**
 * 接口 下线指定在线用户 的 **返回类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/online/kick`
 */
export type CreateOnlineKickResponse = any;

/**
 * 接口 下线指定在线用户 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/online/kick`
 */
type CreateOnlineKickRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/sys/online/kick',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 下线指定在线用户 的 **请求配置**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/online/kick`
 */
const createOnlineKickRequestConfig: CreateOnlineKickRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/sys/online/kick',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'createOnlineKick',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 下线指定在线用户 的 **请求函数**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/online/kick`
 */
export const createOnlineKick = /*#__PURE__*/ (
  requestData: CreateOnlineKickRequest,
  ...args: UserRequestRestArgs
) => {
  return request<CreateOnlineKickResponse>(
    prepare(createOnlineKickRequestConfig, requestData),
    ...args,
  );
};

createOnlineKick.requestConfig = createOnlineKickRequestConfig;

/**
 * 接口 分页获取参数配置列表 的 **请求类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/param-config/page`
 */
export interface FetchParamConfigPageRequest {
  /**
   * 当前页包含数量
   */
  limit?: string;
  /**
   * 当前页包含数量
   */
  page?: string;
}

/**
 * 接口 分页获取参数配置列表 的 **返回类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/param-config/page`
 */
export type FetchParamConfigPageResponse = any;

/**
 * 接口 分页获取参数配置列表 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/param-config/page`
 */
type FetchParamConfigPageRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/sys/param-config/page',
    'data',
    string,
    'limit' | 'page',
    false
  >
>;

/**
 * 接口 分页获取参数配置列表 的 **请求配置**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/param-config/page`
 */
const fetchParamConfigPageRequestConfig: FetchParamConfigPageRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/sys/param-config/page',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: ['limit', 'page'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'fetchParamConfigPage',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 分页获取参数配置列表 的 **请求函数**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/param-config/page`
 */
export const fetchParamConfigPage = /*#__PURE__*/ (
  requestData: FetchParamConfigPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<FetchParamConfigPageResponse>(
    prepare(fetchParamConfigPageRequestConfig, requestData),
    ...args,
  );
};

fetchParamConfigPage.requestConfig = fetchParamConfigPageRequestConfig;

/**
 * 接口 新增参数配置 的 **请求类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/param-config/add`
 */
export interface CreateParamConfigAddRequest {
  /**
   * 参数名称
   */
  name: string;
  /**
   * 参数键名
   */
  key: string;
  /**
   * 参数值
   */
  value: string;
  /**
   * 备注
   */
  remark?: string;
}

/**
 * 接口 新增参数配置 的 **返回类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/param-config/add`
 */
export type CreateParamConfigAddResponse = any;

/**
 * 接口 新增参数配置 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/param-config/add`
 */
type CreateParamConfigAddRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/sys/param-config/add',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 新增参数配置 的 **请求配置**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/param-config/add`
 */
const createParamConfigAddRequestConfig: CreateParamConfigAddRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/sys/param-config/add',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'createParamConfigAdd',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 新增参数配置 的 **请求函数**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/param-config/add`
 */
export const createParamConfigAdd = /*#__PURE__*/ (
  requestData: CreateParamConfigAddRequest,
  ...args: UserRequestRestArgs
) => {
  return request<CreateParamConfigAddResponse>(
    prepare(createParamConfigAddRequestConfig, requestData),
    ...args,
  );
};

createParamConfigAdd.requestConfig = createParamConfigAddRequestConfig;

/**
 * 接口 查询单个参数配置信息 的 **请求类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/param-config/info`
 */
export interface FetchParamConfigInfoRequest {
  /**
   * 需要查询的配置编号
   */
  id: string;
}

/**
 * 接口 查询单个参数配置信息 的 **返回类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/param-config/info`
 */
export interface FetchParamConfigInfoResponse {}

/**
 * 接口 查询单个参数配置信息 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/param-config/info`
 */
type FetchParamConfigInfoRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/sys/param-config/info',
    'data',
    string,
    'id',
    false
  >
>;

/**
 * 接口 查询单个参数配置信息 的 **请求配置**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/param-config/info`
 */
const fetchParamConfigInfoRequestConfig: FetchParamConfigInfoRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/sys/param-config/info',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: ['id'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'fetchParamConfigInfo',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 查询单个参数配置信息 的 **请求函数**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/param-config/info`
 */
export const fetchParamConfigInfo = /*#__PURE__*/ (
  requestData: FetchParamConfigInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<FetchParamConfigInfoResponse>(
    prepare(fetchParamConfigInfoRequestConfig, requestData),
    ...args,
  );
};

fetchParamConfigInfo.requestConfig = fetchParamConfigInfoRequestConfig;

/**
 * 接口 更新单个参数配置 的 **请求类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/param-config/update`
 */
export interface CreateParamConfigUpdateRequest {
  /**
   * 配置编号
   */
  id: number;
  /**
   * 参数名称
   */
  name: string;
  /**
   * 参数值
   */
  value: string;
  /**
   * 备注
   */
  remark?: string;
}

/**
 * 接口 更新单个参数配置 的 **返回类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/param-config/update`
 */
export type CreateParamConfigUpdateResponse = any;

/**
 * 接口 更新单个参数配置 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/param-config/update`
 */
type CreateParamConfigUpdateRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/sys/param-config/update',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 更新单个参数配置 的 **请求配置**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/param-config/update`
 */
const createParamConfigUpdateRequestConfig: CreateParamConfigUpdateRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/sys/param-config/update',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'createParamConfigUpdate',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 更新单个参数配置 的 **请求函数**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/param-config/update`
 */
export const createParamConfigUpdate = /*#__PURE__*/ (
  requestData: CreateParamConfigUpdateRequest,
  ...args: UserRequestRestArgs
) => {
  return request<CreateParamConfigUpdateResponse>(
    prepare(createParamConfigUpdateRequestConfig, requestData),
    ...args,
  );
};

createParamConfigUpdate.requestConfig = createParamConfigUpdateRequestConfig;

/**
 * 接口 删除指定的参数配置 的 **请求类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/param-config/delete`
 */
export interface CreateParamConfigDeleteRequest {
  /**
   * 需要删除的配置id列表
   */
  ids: number[];
}

/**
 * 接口 删除指定的参数配置 的 **返回类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/param-config/delete`
 */
export type CreateParamConfigDeleteResponse = any;

/**
 * 接口 删除指定的参数配置 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/param-config/delete`
 */
type CreateParamConfigDeleteRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/sys/param-config/delete',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 删除指定的参数配置 的 **请求配置**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/param-config/delete`
 */
const createParamConfigDeleteRequestConfig: CreateParamConfigDeleteRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/sys/param-config/delete',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'createParamConfigDelete',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 删除指定的参数配置 的 **请求函数**
 *
 * @分类 default
 * @请求头 `POST /admin/sys/param-config/delete`
 */
export const createParamConfigDelete = /*#__PURE__*/ (
  requestData: CreateParamConfigDeleteRequest,
  ...args: UserRequestRestArgs
) => {
  return request<CreateParamConfigDeleteResponse>(
    prepare(createParamConfigDeleteRequestConfig, requestData),
    ...args,
  );
};

createParamConfigDelete.requestConfig = createParamConfigDeleteRequestConfig;

/**
 * 接口 获取服务器运行信息 的 **请求类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/serve/stat`
 */
export interface FetchServeStatRequest {}

/**
 * 接口 获取服务器运行信息 的 **返回类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/serve/stat`
 */
export interface FetchServeStatResponse {
  /**
   * 运行环境
   */
  runtime: {
    /**
     * 系统
     */
    os: string;
    /**
     * 服务器架构
     */
    arch: string;
    /**
     * Node版本
     */
    nodeVersion: string;
    /**
     * Npm版本
     */
    npmVersion: string;
  };
  /**
   * CPU信息
   */
  cpu: {
    /**
     * 制造商 e.g. Intel(R)
     */
    manufacturer: string;
    /**
     * 品牌	e.g. Core(TM)2 Duo
     */
    brand: string;
    /**
     * 物理核心数
     */
    physicalCores: number;
    /**
     * 型号
     */
    model: string;
    /**
     * 速度 in GHz e.g. 3.4
     */
    speed: number;
    /**
     * CPU资源消耗 原始滴答
     */
    rawCurrentLoad: number;
    /**
     * 空闲CPU资源 原始滴答
     */
    rawCurrentLoadIdle: number;
    /**
     * cpu资源消耗
     */
    coresLoad: {
      /**
       * 当前CPU资源消耗
       */
      rawLoad: number;
      /**
       * 当前空闲CPU资源
       */
      rawLoadIdle: number;
    }[];
  };
  /**
   * 磁盘信息
   */
  disk: {
    /**
     * 磁盘空间大小 (bytes)
     */
    size: number;
    /**
     * 已使用磁盘空间 (bytes)
     */
    used: number;
    /**
     * 可用磁盘空间 (bytes)
     */
    available: number;
  };
  /**
   * 内存信息
   */
  memory: {
    /**
     * total memory in bytes
     */
    total: number;
    /**
     * 可用内存
     */
    available: number;
  };
}

/**
 * 接口 获取服务器运行信息 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/serve/stat`
 */
type FetchServeStatRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/sys/serve/stat',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 获取服务器运行信息 的 **请求配置**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/serve/stat`
 */
const fetchServeStatRequestConfig: FetchServeStatRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/sys/serve/stat',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'fetchServeStat',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 获取服务器运行信息 的 **请求函数**
 *
 * @分类 default
 * @请求头 `GET /admin/sys/serve/stat`
 */
export const fetchServeStat = /*#__PURE__*/ (
  requestData?: FetchServeStatRequest,
  ...args: UserRequestRestArgs
) => {
  return request<FetchServeStatResponse>(
    prepare(fetchServeStatRequestConfig, requestData),
    ...args,
  );
};

fetchServeStat.requestConfig = fetchServeStatRequestConfig;

/**
 * 接口 获取账户资料 的 **请求类型**
 *
 * @分类 default
 * @请求头 `GET /admin/account/info`
 */
export interface FetchInfoRequest {}

/**
 * 接口 获取账户资料 的 **返回类型**
 *
 * @分类 default
 * @请求头 `GET /admin/account/info`
 */
export type FetchInfoResponse = any;

/**
 * 接口 获取账户资料 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `GET /admin/account/info`
 */
type FetchInfoRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/account/info',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 获取账户资料 的 **请求配置**
 *
 * @分类 default
 * @请求头 `GET /admin/account/info`
 */
const fetchInfoRequestConfig: FetchInfoRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/account/info',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'fetchInfo',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 获取账户资料 的 **请求函数**
 *
 * @分类 default
 * @请求头 `GET /admin/account/info`
 */
export const fetchInfo = /*#__PURE__*/ (
  requestData?: FetchInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<FetchInfoResponse>(prepare(fetchInfoRequestConfig, requestData), ...args);
};

fetchInfo.requestConfig = fetchInfoRequestConfig;

/**
 * 接口 更改账户资料 的 **请求类型**
 *
 * @分类 default
 * @请求头 `POST /admin/account/update`
 */
export interface CreateUpdateRequest {
  /**
   * 管理员昵称
   */
  nickName?: string;
  /**
   * 管理员昵称
   */
  username?: string;
  /**
   * 真实姓名
   */
  name?: string;
  /**
   * 邮箱
   */
  email?: string;
  /**
   * 性别
   */
  gender?: number;
  /**
   * 备注
   */
  remark?: string;
  /**
   * 默认路由
   */
  homePath?: string;
}

/**
 * 接口 更改账户资料 的 **返回类型**
 *
 * @分类 default
 * @请求头 `POST /admin/account/update`
 */
export type CreateUpdateResponse = any;

/**
 * 接口 更改账户资料 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `POST /admin/account/update`
 */
type CreateUpdateRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/account/update',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 更改账户资料 的 **请求配置**
 *
 * @分类 default
 * @请求头 `POST /admin/account/update`
 */
const createUpdateRequestConfig: CreateUpdateRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/account/update',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'createUpdate',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 更改账户资料 的 **请求函数**
 *
 * @分类 default
 * @请求头 `POST /admin/account/update`
 */
export const createUpdate = /*#__PURE__*/ (
  requestData: CreateUpdateRequest,
  ...args: UserRequestRestArgs
) => {
  return request<CreateUpdateResponse>(prepare(createUpdateRequestConfig, requestData), ...args);
};

createUpdate.requestConfig = createUpdateRequestConfig;

/**
 * 接口 更改账户密码 的 **请求类型**
 *
 * @分类 default
 * @请求头 `POST /admin/account/password`
 */
export interface CreatePasswordRequest {
  /**
   * 更改前的密码
   */
  originPassword?: string;
  /**
   * 更改后的密码
   */
  newPassword: string;
}

/**
 * 接口 更改账户密码 的 **返回类型**
 *
 * @分类 default
 * @请求头 `POST /admin/account/password`
 */
export type CreatePasswordResponse = any;

/**
 * 接口 更改账户密码 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `POST /admin/account/password`
 */
type CreatePasswordRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/account/password',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 更改账户密码 的 **请求配置**
 *
 * @分类 default
 * @请求头 `POST /admin/account/password`
 */
const createPasswordRequestConfig: CreatePasswordRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/account/password',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'createPassword',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 更改账户密码 的 **请求函数**
 *
 * @分类 default
 * @请求头 `POST /admin/account/password`
 */
export const createPassword = /*#__PURE__*/ (
  requestData: CreatePasswordRequest,
  ...args: UserRequestRestArgs
) => {
  return request<CreatePasswordResponse>(
    prepare(createPasswordRequestConfig, requestData),
    ...args,
  );
};

createPassword.requestConfig = createPasswordRequestConfig;

/**
 * 接口 账户登出 的 **请求类型**
 *
 * @分类 default
 * @请求头 `POST /admin/account/logout`
 */
export interface CreateLogoutRequest {}

/**
 * 接口 账户登出 的 **返回类型**
 *
 * @分类 default
 * @请求头 `POST /admin/account/logout`
 */
export type CreateLogoutResponse = any;

/**
 * 接口 账户登出 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `POST /admin/account/logout`
 */
type CreateLogoutRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/account/logout',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 账户登出 的 **请求配置**
 *
 * @分类 default
 * @请求头 `POST /admin/account/logout`
 */
const createLogoutRequestConfig: CreateLogoutRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/account/logout',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'createLogout',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 账户登出 的 **请求函数**
 *
 * @分类 default
 * @请求头 `POST /admin/account/logout`
 */
export const createLogout = /*#__PURE__*/ (
  requestData?: CreateLogoutRequest,
  ...args: UserRequestRestArgs
) => {
  return request<CreateLogoutResponse>(prepare(createLogoutRequestConfig, requestData), ...args);
};

createLogout.requestConfig = createLogoutRequestConfig;

/**
 * 接口 账户注销 的 **请求类型**
 *
 * @分类 default
 * @请求头 `POST /admin/account/remove`
 */
export interface CreateRemoveRequest {}

/**
 * 接口 账户注销 的 **返回类型**
 *
 * @分类 default
 * @请求头 `POST /admin/account/remove`
 */
export type CreateRemoveResponse = any;

/**
 * 接口 账户注销 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `POST /admin/account/remove`
 */
type CreateRemoveRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/account/remove',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 账户注销 的 **请求配置**
 *
 * @分类 default
 * @请求头 `POST /admin/account/remove`
 */
const createRemoveRequestConfig: CreateRemoveRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/account/remove',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'createRemove',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 账户注销 的 **请求函数**
 *
 * @分类 default
 * @请求头 `POST /admin/account/remove`
 */
export const createRemove = /*#__PURE__*/ (
  requestData?: CreateRemoveRequest,
  ...args: UserRequestRestArgs
) => {
  return request<CreateRemoveResponse>(prepare(createRemoveRequestConfig, requestData), ...args);
};

createRemove.requestConfig = createRemoveRequestConfig;

/**
 * 接口 获取菜单列表及权限列表 的 **请求类型**
 *
 * @分类 default
 * @请求头 `GET /admin/account/permmenu`
 */
export interface FetchPermmenuRequest {}

/**
 * 接口 获取菜单列表及权限列表 的 **返回类型**
 *
 * @分类 default
 * @请求头 `GET /admin/account/permmenu`
 */
export type FetchPermmenuResponse = any;

/**
 * 接口 获取菜单列表及权限列表 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `GET /admin/account/permmenu`
 */
type FetchPermmenuRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/account/permmenu',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 获取菜单列表及权限列表 的 **请求配置**
 *
 * @分类 default
 * @请求头 `GET /admin/account/permmenu`
 */
const fetchPermmenuRequestConfig: FetchPermmenuRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/account/permmenu',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'fetchPermmenu',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 获取菜单列表及权限列表 的 **请求函数**
 *
 * @分类 default
 * @请求头 `GET /admin/account/permmenu`
 */
export const fetchPermmenu = /*#__PURE__*/ (
  requestData?: FetchPermmenuRequest,
  ...args: UserRequestRestArgs
) => {
  return request<FetchPermmenuResponse>(prepare(fetchPermmenuRequestConfig, requestData), ...args);
};

fetchPermmenu.requestConfig = fetchPermmenuRequestConfig;

/**
 * 接口 通过username查找用户ID 的 **请求类型**
 *
 * @分类 default
 * @请求头 `GET /admin/account/userid/{username}`
 */
export interface FetchUseridUsernameRequest {
  username: string;
}

/**
 * 接口 通过username查找用户ID 的 **返回类型**
 *
 * @分类 default
 * @请求头 `GET /admin/account/userid/{username}`
 */
export type FetchUseridUsernameResponse = any;

/**
 * 接口 通过username查找用户ID 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `GET /admin/account/userid/{username}`
 */
type FetchUseridUsernameRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/account/userid/{username}',
    'data',
    'username',
    string,
    false
  >
>;

/**
 * 接口 通过username查找用户ID 的 **请求配置**
 *
 * @分类 default
 * @请求头 `GET /admin/account/userid/{username}`
 */
const fetchUseridUsernameRequestConfig: FetchUseridUsernameRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/account/userid/{username}',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_0,
  paramNames: ['username'],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'fetchUseridUsername',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 通过username查找用户ID 的 **请求函数**
 *
 * @分类 default
 * @请求头 `GET /admin/account/userid/{username}`
 */
export const fetchUseridUsername = /*#__PURE__*/ (
  requestData: FetchUseridUsernameRequest,
  ...args: UserRequestRestArgs
) => {
  return request<FetchUseridUsernameResponse>(
    prepare(fetchUseridUsernameRequestConfig, requestData),
    ...args,
  );
};

fetchUseridUsername.requestConfig = fetchUseridUsernameRequestConfig;

/**
 * 接口 发送短信需要的验证码 的 **请求类型**
 *
 * @分类 default
 * @请求头 `GET /admin/register/sms/captcha/img`
 */
export interface FetchSmsCaptchaImgRequest {
  /**
   * 验证码宽度
   */
  width?: string;
  /**
   * 验证码宽度
   */
  height?: string;
}

/**
 * 接口 发送短信需要的验证码 的 **返回类型**
 *
 * @分类 default
 * @请求头 `GET /admin/register/sms/captcha/img`
 */
export type FetchSmsCaptchaImgResponse = any;

/**
 * 接口 发送短信需要的验证码 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `GET /admin/register/sms/captcha/img`
 */
type FetchSmsCaptchaImgRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/register/sms/captcha/img',
    'data',
    string,
    'width' | 'height',
    false
  >
>;

/**
 * 接口 发送短信需要的验证码 的 **请求配置**
 *
 * @分类 default
 * @请求头 `GET /admin/register/sms/captcha/img`
 */
const fetchSmsCaptchaImgRequestConfig: FetchSmsCaptchaImgRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/register/sms/captcha/img',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: ['width', 'height'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'fetchSmsCaptchaImg',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 发送短信需要的验证码 的 **请求函数**
 *
 * @分类 default
 * @请求头 `GET /admin/register/sms/captcha/img`
 */
export const fetchSmsCaptchaImg = /*#__PURE__*/ (
  requestData: FetchSmsCaptchaImgRequest,
  ...args: UserRequestRestArgs
) => {
  return request<FetchSmsCaptchaImgResponse>(
    prepare(fetchSmsCaptchaImgRequestConfig, requestData),
    ...args,
  );
};

fetchSmsCaptchaImg.requestConfig = fetchSmsCaptchaImgRequestConfig;

/**
 * 接口 注册时的短信验证 的 **请求类型**
 *
 * @分类 default
 * @请求头 `POST /admin/register/sms/register`
 */
export interface CreateSmsRegisterRequest {
  /**
   * 手机号码
   */
  phone: string;
  /**
   * 验证码id
   */
  captchaId: string;
  /**
   * 验证码code
   */
  captchaCode: string;
}

/**
 * 接口 注册时的短信验证 的 **返回类型**
 *
 * @分类 default
 * @请求头 `POST /admin/register/sms/register`
 */
export type CreateSmsRegisterResponse = string;

/**
 * 接口 注册时的短信验证 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `POST /admin/register/sms/register`
 */
type CreateSmsRegisterRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/register/sms/register',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 注册时的短信验证 的 **请求配置**
 *
 * @分类 default
 * @请求头 `POST /admin/register/sms/register`
 */
const createSmsRegisterRequestConfig: CreateSmsRegisterRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/register/sms/register',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'createSmsRegister',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 注册时的短信验证 的 **请求函数**
 *
 * @分类 default
 * @请求头 `POST /admin/register/sms/register`
 */
export const createSmsRegister = /*#__PURE__*/ (
  requestData: CreateSmsRegisterRequest,
  ...args: UserRequestRestArgs
) => {
  return request<CreateSmsRegisterResponse>(
    prepare(createSmsRegisterRequestConfig, requestData),
    ...args,
  );
};

createSmsRegister.requestConfig = createSmsRegisterRequestConfig;

/**
 * 接口 注册时的短信下发状态通知 的 **请求类型**
 *
 * @分类 default
 * @请求头 `POST /admin/register/sms/callback`
 */
export interface CreateSmsCallbackRequest {}

/**
 * 接口 注册时的短信下发状态通知 的 **返回类型**
 *
 * @分类 default
 * @请求头 `POST /admin/register/sms/callback`
 */
export type CreateSmsCallbackResponse = string;

/**
 * 接口 注册时的短信下发状态通知 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `POST /admin/register/sms/callback`
 */
type CreateSmsCallbackRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/register/sms/callback',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 注册时的短信下发状态通知 的 **请求配置**
 *
 * @分类 default
 * @请求头 `POST /admin/register/sms/callback`
 */
const createSmsCallbackRequestConfig: CreateSmsCallbackRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/register/sms/callback',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'createSmsCallback',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 注册时的短信下发状态通知 的 **请求函数**
 *
 * @分类 default
 * @请求头 `POST /admin/register/sms/callback`
 */
export const createSmsCallback = /*#__PURE__*/ (
  requestData?: CreateSmsCallbackRequest,
  ...args: UserRequestRestArgs
) => {
  return request<CreateSmsCallbackResponse>(
    prepare(createSmsCallbackRequestConfig, requestData),
    ...args,
  );
};

createSmsCallback.requestConfig = createSmsCallbackRequestConfig;

/**
 * 接口 注册接口 的 **请求类型**
 *
 * @分类 default
 * @请求头 `POST /admin/register/register`
 */
export interface CreateRegisterRequest {
  /**
   * 用户名
   */
  username: string;
  /**
   * 密码
   */
  password: string;
  /**
   * 手机号码
   */
  phone: string;
  /**
   * 手机验证码
   */
  verifyCode: string;
  /**
   * 手机验证码唯一标识
   */
  verifyId: string;
}

/**
 * 接口 注册接口 的 **返回类型**
 *
 * @分类 default
 * @请求头 `POST /admin/register/register`
 */
export type CreateRegisterResponse = string;

/**
 * 接口 注册接口 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `POST /admin/register/register`
 */
type CreateRegisterRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/register/register',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 注册接口 的 **请求配置**
 *
 * @分类 default
 * @请求头 `POST /admin/register/register`
 */
const createRegisterRequestConfig: CreateRegisterRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/register/register',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'createRegister',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 注册接口 的 **请求函数**
 *
 * @分类 default
 * @请求头 `POST /admin/register/register`
 */
export const createRegister = /*#__PURE__*/ (
  requestData: CreateRegisterRequest,
  ...args: UserRequestRestArgs
) => {
  return request<CreateRegisterResponse>(
    prepare(createRegisterRequestConfig, requestData),
    ...args,
  );
};

createRegister.requestConfig = createRegisterRequestConfig;

/**
 * 接口 验证用户名或手机号 的 **请求类型**
 *
 * @分类 default
 * @请求头 `GET /admin/register/checkUser`
 */
export interface FetchCheckUserRequest {
  /**
   * 用户名
   */
  username?: string;
  /**
   * 手机号
   */
  phone?: string;
}

/**
 * 接口 验证用户名或手机号 的 **返回类型**
 *
 * @分类 default
 * @请求头 `GET /admin/register/checkUser`
 */
export type FetchCheckUserResponse = string;

/**
 * 接口 验证用户名或手机号 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `GET /admin/register/checkUser`
 */
type FetchCheckUserRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/register/checkUser',
    'data',
    string,
    'username' | 'phone',
    false
  >
>;

/**
 * 接口 验证用户名或手机号 的 **请求配置**
 *
 * @分类 default
 * @请求头 `GET /admin/register/checkUser`
 */
const fetchCheckUserRequestConfig: FetchCheckUserRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/register/checkUser',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: ['username', 'phone'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'fetchCheckUser',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 验证用户名或手机号 的 **请求函数**
 *
 * @分类 default
 * @请求头 `GET /admin/register/checkUser`
 */
export const fetchCheckUser = /*#__PURE__*/ (
  requestData: FetchCheckUserRequest,
  ...args: UserRequestRestArgs
) => {
  return request<FetchCheckUserResponse>(
    prepare(fetchCheckUserRequestConfig, requestData),
    ...args,
  );
};

fetchCheckUser.requestConfig = fetchCheckUserRequestConfig;

/**
 * 接口 \/admin\/qrcode\/qrcode\/generate 的 **请求类型**
 *
 * @分类 default
 * @请求头 `GET /admin/qrcode/qrcode/generate`
 */
export interface FetchQrcodeGenerateRequest {}

/**
 * 接口 \/admin\/qrcode\/qrcode\/generate 的 **返回类型**
 *
 * @分类 default
 * @请求头 `GET /admin/qrcode/qrcode/generate`
 */
export interface FetchQrcodeGenerateResponse {}

/**
 * 接口 \/admin\/qrcode\/qrcode\/generate 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `GET /admin/qrcode/qrcode/generate`
 */
type FetchQrcodeGenerateRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/qrcode/qrcode/generate',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 \/admin\/qrcode\/qrcode\/generate 的 **请求配置**
 *
 * @分类 default
 * @请求头 `GET /admin/qrcode/qrcode/generate`
 */
const fetchQrcodeGenerateRequestConfig: FetchQrcodeGenerateRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/qrcode/qrcode/generate',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'fetchQrcodeGenerate',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 \/admin\/qrcode\/qrcode\/generate 的 **请求函数**
 *
 * @分类 default
 * @请求头 `GET /admin/qrcode/qrcode/generate`
 */
export const fetchQrcodeGenerate = /*#__PURE__*/ (
  requestData?: FetchQrcodeGenerateRequest,
  ...args: UserRequestRestArgs
) => {
  return request<FetchQrcodeGenerateResponse>(
    prepare(fetchQrcodeGenerateRequestConfig, requestData),
    ...args,
  );
};

fetchQrcodeGenerate.requestConfig = fetchQrcodeGenerateRequestConfig;

/**
 * 接口 \/admin\/qrcode\/qrcode\/verify 的 **请求类型**
 *
 * @分类 default
 * @请求头 `POST /admin/qrcode/qrcode/verify`
 */
export interface CreateQrcodeVerifyRequest {}

/**
 * 接口 \/admin\/qrcode\/qrcode\/verify 的 **返回类型**
 *
 * @分类 default
 * @请求头 `POST /admin/qrcode/qrcode/verify`
 */
export interface CreateQrcodeVerifyResponse {}

/**
 * 接口 \/admin\/qrcode\/qrcode\/verify 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `POST /admin/qrcode/qrcode/verify`
 */
type CreateQrcodeVerifyRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/qrcode/qrcode/verify',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 \/admin\/qrcode\/qrcode\/verify 的 **请求配置**
 *
 * @分类 default
 * @请求头 `POST /admin/qrcode/qrcode/verify`
 */
const createQrcodeVerifyRequestConfig: CreateQrcodeVerifyRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/qrcode/qrcode/verify',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'createQrcodeVerify',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 \/admin\/qrcode\/qrcode\/verify 的 **请求函数**
 *
 * @分类 default
 * @请求头 `POST /admin/qrcode/qrcode/verify`
 */
export const createQrcodeVerify = /*#__PURE__*/ (
  requestData?: CreateQrcodeVerifyRequest,
  ...args: UserRequestRestArgs
) => {
  return request<CreateQrcodeVerifyResponse>(
    prepare(createQrcodeVerifyRequestConfig, requestData),
    ...args,
  );
};

createQrcodeVerify.requestConfig = createQrcodeVerifyRequestConfig;

/**
 * 接口 \/admin\/qrcode\/qrcode\/check-status 的 **请求类型**
 *
 * @分类 default
 * @请求头 `GET /admin/qrcode/qrcode/check-status`
 */
export interface FetchQrcodeCheckStatusRequest {
  qrCodeId: string;
}

/**
 * 接口 \/admin\/qrcode\/qrcode\/check-status 的 **返回类型**
 *
 * @分类 default
 * @请求头 `GET /admin/qrcode/qrcode/check-status`
 */
export interface FetchQrcodeCheckStatusResponse {}

/**
 * 接口 \/admin\/qrcode\/qrcode\/check-status 的 **请求配置的类型**
 *
 * @分类 default
 * @请求头 `GET /admin/qrcode/qrcode/check-status`
 */
type FetchQrcodeCheckStatusRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/admin/qrcode/qrcode/check-status',
    'data',
    string,
    'qrCodeId',
    false
  >
>;

/**
 * 接口 \/admin\/qrcode\/qrcode\/check-status 的 **请求配置**
 *
 * @分类 default
 * @请求头 `GET /admin/qrcode/qrcode/check-status`
 */
const fetchQrcodeCheckStatusRequestConfig: FetchQrcodeCheckStatusRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/admin/qrcode/qrcode/check-status',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: ['qrCodeId'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'fetchQrcodeCheckStatus',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 \/admin\/qrcode\/qrcode\/check-status 的 **请求函数**
 *
 * @分类 default
 * @请求头 `GET /admin/qrcode/qrcode/check-status`
 */
export const fetchQrcodeCheckStatus = /*#__PURE__*/ (
  requestData: FetchQrcodeCheckStatusRequest,
  ...args: UserRequestRestArgs
) => {
  return request<FetchQrcodeCheckStatusResponse>(
    prepare(fetchQrcodeCheckStatusRequestConfig, requestData),
    ...args,
  );
};

fetchQrcodeCheckStatus.requestConfig = fetchQrcodeCheckStatusRequestConfig;

/* prettier-ignore-end */
